import Vue from "vue";
import Router from "vue-router";

import { PageNotFound } from "./shared/components";
import adminRoutes from "@/app/admin/admin-routes";

const baseRoutes = [
    {
        path: "/",
        redirect: "/users",
    },
    {
        path: "/404",
        name: "Page404",
        component: PageNotFound,
    },
];

Vue.use(Router);
const router = new Router({
    mode: "history",
    routes: [
        ...baseRoutes,
        ...adminRoutes,
        {
            path: "*",
            redirect: "/404",
        },
    ],
});

export default router;
